export enum FilterType {
  NAME_ASC = 'NOMBRE, A - Z',
  NAME_DESC = 'NOMBRE, Z - A',
  SCORE_DESC = '% Mayor - Menor',
  SCORE_ASC = '% Menor - Mayor'
}

export const FILTER_TYPES = Object.values(FilterType)
